export class BackupScopeResourcesLosingBackupCountResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return BackupScopeResourcesLosingBackupCountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
